(function () {
    'use strict';
    angular
        .module('laekkerAI.tablet')
        .component('forceCheckinQuestion', {
            controller: 'ForceCheckinQuestionController',
            templateUrl: '/components/force-checkin-question/force-checkin-question.html',
            bindings: {
                'resolve': '<',
                'close': '&'
            }
        });
})();